import styles from './StatusPageHeader.module.css';

// Brand header (logo + divider) shared by full-page states such as the
// maintenance page and the suspended-account page.
export function StatusPageHeader() {
  return (
    <>
      <h1 className={`title big ${styles.logo}`}>Dermalink</h1>
      <hr className={styles.divider} />
    </>
  );
}
